module.exports = __webpack_public_path__ + "static/media/Exclamation_Icon@3x.0ff952f8.png";